module.exports = __webpack_public_path__ + "img/PicsIphone.5728b525.png";